<div class="row">
  <div class="col-sm-12">
    <app-card>
      <div class="row justify-content-center">
        <div class="col-md-12 text-center">
          <h2>Verify your Identity</h2>
        </div>
      </div>
      <div class="row justify-content-center" *ngIf="safeUrl">
        <iframe [src]="safeUrl" style="height: 100vh;width: 100vw" allow="microphone; camera" title="Verification"></iframe>
      </div>

    </app-card>
  </div>
</div>
